import React from 'react';
import EkoVideo from 'we-sdk/components/WeSdkEkoVideo';
import qs from 'query-string';
import { sendEmbedApiV1MessageToParent } from '../lib/utils';
const PDP_CONTEXT_ID = 'cc5jqNEz';

export default function PDPVideo({ params, events, location, ...props }) {
    const queryParams = qs.parse(location?.search || '');

    return (
        <EkoVideo appId={process.env.app_id} expandToFillContainer={true}
                  params={{ context: PDP_CONTEXT_ID, ...params }}
                  events={{
                        // Pass any event being listened to the parent frame
                      ...queryParams?.events?.split(',').reduce((value, current) => {
                          value[current] = (...args) => {
                              // If the event arguments represent a node metadata, we send it the same way we used to
                              // handle interactions.report
                              if (args[0] && args[0].id && args[0].data) {
                                  let id = (args[0] && args[0].id) || 'unknown';
                                  let metadata = args[0] && args[0].data;
                                  sendEmbedApiV1MessageToParent(current, id, { metadata });
                              } else {
                                  sendEmbedApiV1MessageToParent(current);
                              }
                          };
                          return value;
                      }, {}),
                      ...events
                  }}
                  {...props} />
    );
}
